module.exports = __webpack_public_path__ + "img/infoicon.9ce44a1e.svg";